module.exports = __webpack_public_path__ + "img/bot_lj.fa74d6d5.png";